import { jsx as _jsx } from "react/jsx-runtime";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { useMemo } from "react";
/**
 * SortableList component
 *
 * This component renders a sortable list using the @dnd-kit library.
 * The items to be sorted are derived from the `fields` prop, and the sorting
 * functionality can be customized via the `options` prop.
 *
 * @param fields - The list of fields to be sorted, each containing a unique key.
 * @param children - The child elements to be rendered within the SortableList.
 * @param options - Additional options to be passed to the SortableContext component, excluding 'items' and 'children'.
 * @returns A SortableContext component wrapping the provided children.
 */ const SortableList = ({ fields, children, options })=>{
    // memoize items to avoid unnecessary recalculations
    const items = useMemo(()=>{
        return fields.map((dataRow)=>{
            return String(dataRow.key);
        });
    }, [
        fields
    ]);
    return /*#__PURE__*/ _jsx(SortableContext, {
        items: items,
        strategy: verticalListSortingStrategy,
        ...options,
        children: children
    });
};
export { SortableList };
